export default __webpack_public_path__ + "static/media/excavator.88bb0272.jpg";